<template>
    <div class="content container">

        <hr>
        <h2 class="text-center">
            Meine Arbeitsweise
        </h2>
        <hr>

        <p class="lead text-center content-highlight">
            Das übergeordnete Ziel besteht darin, wirksame Strategien und Methoden zu erlernen, um diese
            auch langfristig und selbständig im Leben anwenden zu können: <b>Hilfe zur Selbsthilfe</b>.
        </p>

        <div class="row">

            <div class="col-lg-6">

                <p>
                    Möglicherweise befinden Sie sich aktuell in einer Krise oder erleben sich als hilflos, Sie sehen
                    sich mit scheinbar unlösbaren Problemen und Hindernissen konfrontiert und entwickeln daraufhin
                    Symptome, um diese Situationen erträglicher zu machen. Teilweise erscheinen diese Symptome
                    (Ängste, Zwänge, körperliche Beschwerden, Depressionen) jedoch auch aus heiterem Himmel zu
                    kommen ohne dass Sie sie einordnen können.
                </p>
                <p>
                    Gerne möchte ich mich mit Ihnen ihren individuellen Herausforderungen und Symptomatiken zuwenden und
                    gemeinsam neue Lösungen oder Hilfestellungen erarbeiten. Ich möchte Sie <b>zu Veränderungen
                    ermutigen</b>,
                    Ihnen helfen <b>neue Wege</b> auszuprobieren und Sie darauf vorbereiten, dass Sie <b>langfristig
                    eigene
                    Strategien entwickeln</b> können, um mit schwierigen Situationen und Symptomen selbständig umgehen
                    zu
                    können.
                </p>
            </div>
            <div class="col-lg-6 text-justify">
                <p>
                    Im Rahmen der <b>Verhaltenstherapie</b> arbeite ich unter Berücksichtigung ihrer persönlichen
                    Erfahrungen und Werte mit anerkannten und wirksamen Methoden. Wir starten mit einer <b>Analyse der
                    Entstehungsbedingungen</b> (Problemanalyse), um dann geeignete Ansatzpunkte finden zu können. Wir
                    wollen wenig hilfreiche Strategien und Verhaltensweisen identifizieren und in angeleiteten
                    kleinschrittigen Verfahren verändern, um so wieder mit <b>mehr Lebensfreude und flexibleren
                    Verhaltensmustern</b> durchs Leben gehen zu können. Neben den klassischen verhaltenstherapeutischen
                    Methoden (beispielsweise kognitives Umstrukturieren, Expositionen, Entspannungsverfahren) arbeite
                    ich auch mit <b>körperorientierten und emotionsfokussierten Techniken</b> welche sich wunderbar in
                    den
                    Gesamtprozess einordnen lassen.
                </p>
            </div>
        </div>

        <!--        <div class="content-image"></div>-->

        <!--        <br>-->
        <!--        <div class="content-highlight">-->
        <!--            <h4 class="text-center">Ich biete Ihnen Therapie vor Allem für folgende Störungsbilder an:</h4>-->

        <!--            <ul class="text-center list-unstyled">-->
        <!--                <li>Depressionen</li>-->
        <!--                <li>Ängste (Phobien, Panikstörung, Generalisierte Angststörung)</li>-->
        <!--                <li>Akute Belastungen u. Posttraumatische Belastungsstörungen, Anpassungsstörungen</li>-->
        <!--                <li>Zwänge</li>-->
        <!--                <li>Essstörungen</li>-->
        <!--                <li>Burnout</li>-->
        <!--                <li>Schlafstörungen</li>-->
        <!--                <li>Psychosomatische Erkrankungen</li>-->
        <!--                <li>Beziehungsprobleme</li>-->
        <!--                <li>Persönlichkeitsstörungen</li>-->
        <!--            </ul>-->
        <!--        </div>-->

    </div>

</template>

<script>
    export default {
        name: 'ContentMethods',
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content {
    }

    .content-image {
        background-image: url("../assets/weg.jpg");
    }
</style>
